import {Component, inject, OnInit} from '@angular/core';
import {PTableCellValueComponent} from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import {PageTitleComponent} from '@shared/components/page-title/page-title.component';
import {ResourceByIdPipe} from '@shared/pipes/resource-by-id.pipe';
import {Table} from '@primeng/table';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BasicTableComponent} from '@common/references/basic-table.component';
import {Router, RouterLink} from '@angular/router';
import {ModalClose} from '@shared/services/modal/modal.enum';
import {getResourceById, Resources} from '@app/resources';
import {RentersFormComponent} from '@modules/universal-billing/renters/renters-form/renters-form.component';
import {RentersService} from '@modules/universal-billing/renters/renters.service';
import { ClientTypesLabels } from '@modules/universal-billing/renters/renters.enum';

@Component({
  selector: 'app-renters',
  standalone: true,
  imports: [
    PTableCellValueComponent,
    PageTitleComponent,
    ResourceByIdPipe,
    Table,
    TranslatePipe,
    RouterLink
  ],
  templateUrl: './renters.component.html',
  styleUrl: './renters.component.scss'
})
export class RentersComponent extends BasicTableComponent<any> implements OnInit {
  public breadCrumbItems = [];
  service = inject(RentersService);
  router = inject(Router);
  translate = inject(TranslateService);

  translateService = inject(TranslateService);

  type: string = 'private'
  ngOnInit() {
    super.ngOnInit();
    this.breadCrumbItems = [
      { label: 'MENU.UNIVERSAL_BILLING', iconClass: 'las la-settings' },
      { label: this.service.title, active: true }
    ];
  }

  onAdd() {
    this.modalService.open({
      component: RentersFormComponent,
      title: this.translate.instant('ADD_RENTERS'),
      componentOptions: {
        modalType: 'user'
      },
      modalOptions: {
        size: 'lg',
      }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData()
      }
    })
  }

  onView(data: any) {
    this.router.navigate([getResourceById(Resources.RentersDetails, data.id)]);
  }

  protected readonly ClientTypesLabels = ClientTypesLabels;
}
